import styles from "./search-filter.module.css";
export default function SearchFilter(props: {
  brandAgg: IBrandAgg[];
  priceAgg: any[];
  query: string | undefined;
  totalRows: number;
  setValidPriceRanges: Function;
  validPriceRanges: any[];
  validBrands: string[];
  setValidBrands: Function;
  defaultSortOrder: string;
  setDefaultSortOrder: Function;
}) {
  return (
    <>
      <div className={styles.searchFilterContainer}>
        <section className={styles.summary}>
          <span>Søkeord</span>
          <strong>&ldquo;{props.query}&rdquo;</strong>
          <small>{props.totalRows} treff</small>
        </section>
        <br />
        <section>
          <div className={styles.header}>Sortering</div>
          <select
            className={styles.select}
            value={props.defaultSortOrder}
            onChange={(e) => {
              e.stopPropagation();
              const sortOrder = e.target.value.toString();
              props.setDefaultSortOrder(sortOrder);
            }}
          >
            <option value="relevance">Mest relevant</option>
            <option value="priceASC">Pris lav til høy</option>
            <option value="priceDESC">Pris høy til lav</option>
          </select>
        </section>
        <br />
        <section>
          <div className={styles.header}>Pris</div>
          {props.priceAgg.map((agg: any, index: number) => {
            return (
              <div className={styles.option} key={agg.id + index.toString()}>
                <input
                  type="checkbox"
                  checked={props.validPriceRanges.some(
                    (range: { min: number }) => range.min === agg._id,
                  )}
                  id={agg._id}
                  name={agg._id}
                  onChange={() => {
                    if (
                      props.validPriceRanges.findIndex(
                        (r: { min: number; max: number }) => r.min === agg._id,
                      ) > -1
                    ) {
                      const newValidPriceRanges = props.validPriceRanges.filter(
                        (range: any) => range.min !== agg._id,
                      );
                      props.setValidPriceRanges(newValidPriceRanges);
                    } else {
                      props.setValidPriceRanges([
                        ...props.validPriceRanges,
                        {
                          min: agg._id,
                          max: props.priceAgg[index + 1]?._id - 1 || 990000,
                        },
                      ]);
                    }
                  }}
                />
                <label className={styles.aggLabel} htmlFor={agg._id}>
                  {agg._id} - {props.priceAgg[index + 1]?._id - 1 || ""} (
                  {agg.count})
                </label>
              </div>
            );
          })}
        </section>
        <br />
        <section>
          <div className={styles.header}>Merker</div>
          <div className={styles.filterWrapper}>
            {props.brandAgg.map((agg: any, index: number) => {
              return (
                <div className={styles.option} key={agg.id + index.toString()}>
                  <input
                    type="checkbox"
                    checked={props.validBrands.indexOf(agg._id) > -1}
                    id={agg._id}
                    name={agg._id}
                    onChange={() => {
                      if (
                        props.validBrands.findIndex(
                          (r: string) => r === agg._id,
                        ) > -1
                      ) {
                        const newValidBrands = props.validBrands.filter(
                          (a: string) => a !== agg._id,
                        );
                        props.setValidBrands(newValidBrands);
                      } else {
                        props.setValidBrands([...props.validBrands, agg._id]);
                      }
                    }}
                  />
                  <label className={styles.aggLabel} htmlFor={agg._id}>
                    {`${agg._id.substring(0, 1).toUpperCase()}${agg._id.substring(1, agg._id.length).toLowerCase()}`}{" "}
                    ({agg.numberOfProducts})
                  </label>
                </div>
              );
            })}
          </div>
        </section>
        <div style={{marginTop: '64px', textAlign: 'center'}} className="hideInMobile hideOnPad">
        <a href="https://track.adtraction.com/t/t?a=1990593973&as=1977603278&t=2&tk=1"><img src="https://track.adtraction.com/t/t?a=1990593973&as=1977603278&t=1&tk=1&i=1" width="188" height="610" /></a>
        </div>
      </div>
    </>
  );
}

export interface IBrandAgg {
  _id: string;
  numberOfProducts: number;
}
